import { cacheFn } from '@shared-components-web/utils/cacheFn/cacheFn';
import { getGraphHeaders } from '@shared-components-web/utils/getGraphHeaders';
import { logWarning } from '@shared-components-web/utils/miscUtils';
import { BffBrandType } from '@src/lib/__generated/beffe/sdk';

const BFF_FACILITY_BY_ID_QUERY = `
query bffFacilityById($brand: BffBrandType!, $id: String!) {
	facilityById(brand: $brand, id: $id) {
		name
		id
		code
		brand
		phoneNumber
		scheduleAppointmentURL
		schedulingSystem
		revspringAccountId
		revspringLocationValue
		address {
			address1
			address2
			city
			stateCode
			zipCode
		}
		location {
			distance
			landmarks
			latitude
			longitude
			neighboringAreas
			timeZone
		}
		workingHours {
			date
			open {
				from
				to
			}
		}
		status
		comingSoon
		openDate
		attributes {
			name
			value
		}
		email
	}
}
`;

export const getBffFacilityById = cacheFn(
	async (brand: BffBrandType, id: string, url: string, appName: string, appVersion: string) => {
		try {
			if (!brand) {
				return null;
			}
			const { getBeffeGraphQlClient } = await import('@src/lib/client');
			const response = await getBeffeGraphQlClient(url)
				.query<{ facilityById: unknown }>(
					BFF_FACILITY_BY_ID_QUERY,
					{
						brand: brand as never,
						id,
					},
					{ fetchOptions: { headers: getGraphHeaders(appName, appVersion) } }
				)
				.toPromise();

			return response.data;
		} catch {
			logWarning(`Could not find any facilities data for: ${brand} for query: ${id}`);
		}
	}
);
